import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";
import { PhoneInput } from "@/components";

const FormPhoneInput = ({
  name,
  label,
  control,
  error,
  isRequired,
  onChange,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel className="!z-[2]">
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <PhoneInput
            {...field}
            {...rest}
            onChange={(phone: any, countryData: any) => {
              if (onChange) onChange(phone, countryData);
              field.onChange(phone);
            }}
          />
        )}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormPhoneInput;
